// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","tertiary":"#BFD730","crumbs":"_3R5w","dark":"O3-r","crumb":"_37Mc","circle":"_2KdE","active":"_18Kb","title":"sqFI"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/BreadCrumbs/Crumbs.scss
// module id = gfZZ
// module chunks = 0